import { TreeItem } from '../../../tree-summary/tree-summary.component';
import { BomImportPreviewNodeDto } from './bom-import-preview.dto';

// One line of the read-only tree table: the preview tree flattened depth-first, the way it will be created,
// with every value the importer read from the sheet row and will write into the catalogue (0087)
export interface PreviewRow {
  depth: number;
  name: string;
  partNumber?: string;
  description?: string;
  massKg?: number;
  amount: number;
  unit: string;
  existingName?: string;
}

export function flattenPreview(node: BomImportPreviewNodeDto, depth = 0): PreviewRow[] {
  const row: PreviewRow = {
    depth,
    name: node.name,
    partNumber: node.partNumber,
    description: node.description,
    massKg: node.massKg,
    amount: node.amount,
    unit: node.unit,
    existingName: node.existingName
  };

  return [row, ...node.children.flatMap(child => flattenPreview(child, depth + 1))];
}

// PODSUMOWANIE folds by bomItemId. A matched row has one (the API sends null otherwise); a new row gets a stand-in
// keyed on what makes it one item for the API (part number, or name without one), negative so it can never meet a real id
export function toTreeItem(node: BomImportPreviewNodeDto, standInIds = new Map<string, number>()): TreeItem {
  const bomItemId = node.existingBomItemId ?? standInId(node.partNumber ?? node.name, standInIds);

  return {
    data: { bomItemId, name: node.name, amount: node.amount, unit: node.unit, massKg: node.massKg, structure: node.structure },
    children: node.children.map(child => toTreeItem(child, standInIds))
  };
}

function standInId(identity: string, standInIds: Map<string, number>): number {
  if (!standInIds.has(identity)) {
    standInIds.set(identity, -(standInIds.size + 1));
  }

  return standInIds.get(identity)!;
}
